import API from "@/utils/axiosApi/powderedMilkApi";
export default {
  name: "",
  data() {
    return {
      show: true,//答案是否展开
      title: "",//标题
      answerlist: [],//历史列表
      pointLoading: false,
      pointFinished: false,
      pointError: false,
      finishText: "",
      finishShow: false,
      detailParams: {
        pageNum: 1,
        pageSize: 20
      }
    };
  },
  methods: {
    yesAnswer() {
      this.show = true;
    },
    Historylist() {
      // 获取历史列表
      API.getHistorylist({}, { pageNum: this.detailParams.pageNum, pageSize: 20, crmId: this.crmId }, res => {
        this.pointLoading = false
        if (res.code == 200) {
          var pointData = res.data.content
          if (pointData == null) pointData = []
          this.answerlist = this.answerlist.concat(pointData)
          if (this.detailParams.pageNum >= Math.ceil(res.data.totalElements / this.detailParams.pageSize) || Math.ceil(res.data.totalElements / this.detailParams.pageSize) === 0) {
            this.pointFinished = true;
            this.finishText = "——已经到底了哦——";
          } else {
            this.detailParams.pageNum += 1;
          }
          if (this.detailParams.pageNum == 1 && this.answerlist.length == 0) {
            this.finishText = "";
            this.finishShow = true;
          }
        } else {
          this.pointLoading = false;
          this.pointError = true;
        }
      }, (res) => {
        this.pointLoading = false;
        this.pointError = true;
      });
    }
  },
  mounted() {
    //请求接口，获取问题答案和解析
    // 每日辟谣查询历史列表
    //接口请求历史查询
    if (JSON.parse(localStorage.getItem("userInfo")) == null) {
      this.crmId = ''
    } else {
      this.crmId = JSON.parse(localStorage.getItem("userInfo")).crm_id
    }
  }
};
